import store from '@/state/store';

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/account/login.vue'),
        meta: {
            title: 'Login',
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('../views/account/register.vue'),
        meta: {
            title: 'Register',
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () => import('../views/account/forgot-password.vue'),
        meta: {
            title: 'Forgot Password',
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: '/',
        name: 'default',
        meta: {
            title: 'Dashboard',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/dashboard/index.vue'),
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            title: 'Logout',
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                localStorage.clear();
                sessionStorage.clear();
                next();
            },
        },
        component: () => import('../views/account/logout'),
    },
    {
        path: '/auth/signin-basic',
        name: 'signin-basic',
        meta: {
            title: 'Signin Basic',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/signin/basic'),
    },
    {
        path: '/auth/signin-cover',
        name: 'signin-cover',
        meta: {
            title: 'Signin Cover',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/signin/cover'),
    },
    {
        path: '/auth/signup-basic',
        name: 'signup-basic',
        meta: {
            title: 'Signup Basic',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/signup/basic'),
    },
    {
        path: '/auth/signup-cover',
        name: 'signup-cover',
        meta: {
            title: 'Signup Cover',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/signup/cover'),
    },
    {
        path: '/auth/reset-pwd-basic',
        name: 'reset-pwd-basic',
        meta: {
            title: 'Reset Password',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/reset/basic'),
    },
    {
        path: '/auth/reset-pwd-cover',
        name: 'reset-pwd-cover',
        meta: {
            title: 'Reset Password',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/reset/cover'),
    },
    {
        path: '/auth/create-pwd-basic',
        name: 'create-pwd-basic',
        meta: {
            title: 'create Password',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/create/basic'),
    },
    {
        path: '/auth/create-pwd-cover',
        name: 'create-pwd-cover',
        meta: {
            title: 'create Password',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/create/cover'),
    },
    {
        path: '/auth/lockscreen-basic',
        name: 'lock-screen-basic',
        meta: {
            title: 'Lock Screen',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/lockscreen/basic'),
    },
    {
        path: '/auth/lockscreen-cover',
        name: 'lock-screen-cover',
        meta: {
            title: 'Lock Screen',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/lockscreen/cover'),
    },
    {
        path: '/auth/twostep-basic',
        name: 'twostep-basic',
        meta: {
            title: 'Two Step Auth',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/twostep/basic'),
    },
    {
        path: '/auth/twostep-cover',
        name: 'twostep-cover',
        meta: {
            title: 'Two Step Auth',
            authRequired: true,
            appRoles: ['ROLE_ADMIN'],
        },
        component: () => import('../views/auth/twostep/cover'),
    },
    {
        path: '/inbox',
        name: 'Inbox',
        meta: { title: 'Inbox', authRequired: true, mailToegang: true },
        component: () => import('../views/inbox/index.vue'),
    },
    {
        path: '/quotes/list',
        name: 'Offertes',
        meta: { title: 'Offertes', authRequired: true },
        component: () => import('../views/quotes/list'),
    },
    {
        path: '/quotes/board',
        name: 'Offertebord',
        meta: { title: 'Offertebord', authRequired: true, mailToegang: true },
        component: () => import('../views/quotes/board.vue'),
    },
    {
        path: '/quotes/board/:entityId',
        name: 'Offerte werkplek',
        meta: { title: 'Offerte werkplek', authRequired: true, mailToegang: true },
        component: () => import('../views/quotes/workspace.vue'),
    },
    {
        path: '/quotes/priorities',
        name: 'Offerte-prioriteiten',
        meta: { title: 'Offerte-prioriteiten', authRequired: true },
        component: () => import('../views/quotes/priorities.vue'),
    },
    {
        path: '/quotes/create',
        name: 'Offerte aanmaken',
        meta: { title: 'Offerte aanmaken', authRequired: true },
        component: () => import('../views/quotes/create'),
    },
    {
        path: '/quotes/detail/:entityId',
        name: 'Offerte bewerken',
        meta: { title: 'Offerte bewerken', authRequired: true },
        component: () => import('../views/quotes/detail'),
    },
    {
        path: '/leads',
        name: 'Aanvragen beoordelen',
        meta: { title: 'Aanvragen beoordelen', authRequired: true },
        component: () => import('../views/leads/index'),
    },
    {
        path: '/gesprekken',
        name: 'Gesprekken',
        meta: { title: 'Gesprekken', authRequired: true },
        component: () => import('../views/calls/index'),
    },
    {
        path: '/chats',
        name: 'Chats',
        meta: { title: 'Chats', authRequired: true },
        component: () => import('../views/chats/index'),
    },
    {
        path: '/inkoop-controle',
        name: 'Inkoopcontrole',
        meta: { title: 'Inkoopcontrole', authRequired: true },
        component: () => import('../views/profit/cost-check'),
    },
    {
        path: '/orders/overview',
        name: 'Orderoverzicht',
        meta: { title: 'Orders', authRequired: true },
        component: () => import('../views/orders/overview'),
    },
    {
        path: '/orders/list',
        name: 'Orders',
        meta: { title: 'Orders', authRequired: true },
        component: () => import('../views/orders/list'),
    },
    {
        path: '/orders/create',
        name: 'Order aanmaken',
        meta: { title: 'Order aanmaken', authRequired: true },
        component: () => import('../views/orders/create'),
    },
    {
        path: '/orders/detail/:entityId',
        name: 'Order bewerken',
        meta: { title: 'Order bewerken', authRequired: true },
        component: () => import('../views/orders/detail'),
    },
    {
        path: '/companies/list',
        name: 'Bedrijven',
        meta: { title: 'Contactpersoon', authRequired: true },
        component: () => import('../views/companies/list'),
    },
    {
        path: '/companies/create',
        name: 'Bedrijf aanmaken',
        meta: { title: 'Bedrijf aanmaken', authRequired: true },
        component: () => import('../views/companies/create'),
    },
    {
        path: '/companies/detail/:companyId',
        name: 'Bedrijf bewerken',
        meta: { title: 'Bedrijf bewerken', authRequired: true },
        component: () => import('../views/companies/detail'),
    },
    {
        path: '/customers/list',
        name: 'Contactpersonen',
        meta: { title: 'Contactpersonen', authRequired: true },
        component: () => import('../views/customers/list'),
    },
    {
        path: '/customers/create',
        name: 'Contactpersoon aanmaken',
        meta: { title: 'Contactpersoon aanmaken', authRequired: true },
        component: () => import('../views/customers/create'),
    },
    {
        path: '/customers/detail/:customerId',
        name: 'Contactpersoon bewerken',
        meta: { title: 'Contactpersoon bewerken', authRequired: true },
        component: () => import('../views/customers/detail'),
    },
    {
        path: '/purchase-orders/list/:orderNumber?',
        name: 'Inkooporders',
        meta: { title: 'Inkooporders', authRequired: true },
        component: () => import('../views/purchase-orders/list'),
    },
    {
        path: '/purchase-orders/detail/:entityId',
        name: 'Inkooporder',
        meta: { title: 'Inkooporder', authRequired: true },
        component: () => import('../views/purchase-orders/detail'),
    },
    {
        path: '/playground/index',
        name: 'Playground',
        meta: { title: 'Playground', authRequired: true },
        component: () => import('../views/playground/index'),
    },
    {
        path: '/calendar/index',
        name: 'Calendar',
        meta: { title: 'Calendar', authRequired: true },
        component: () => import('../views/calendar/index'),
    },
    {
        path: '/not-allowed',
        name: 'Niet toegestaan',
        meta: { title: 'Niet toegestaan', appRoles: ['ROLE_ADMIN', 'ROLE_CONTACT', 'ROLE_USER'] },
        component: () => import('../views/not-allowed/index'),
    },
    {
        path: '/reports/kiyoh',
        name: 'Kiyoh overzicht',
        meta: { title: 'Kiyoh overzicht', authRequired: true },
        component: () => import('../views/reports/kiyoh'),
    },
    {
        path: '/reports/quote-reminder',
        name: 'Offerte herinnering',
        meta: { title: 'Offerte herinnering', authRequired: true },
        component: () => import('../views/reports/quote-reminder'),
    },
    {
        path: '/dashboard/ads',
        name: 'Google Ads dashboard',
        meta: { title: 'Google Ads dashboard', authRequired: true },
        component: () => import('../views/dashboard/ads.vue'),
    },
    {
        path: '/reports/margin',
        name: 'Marge controle',
        meta: { title: 'Marge controle', authRequired: true },
        component: () => import('../views/reports/margin'),
    },
    {
        path: '/reports/smt-coverage',
        name: 'SMT-dekking per leverancier',
        meta: { title: 'SMT-dekking per leverancier', authRequired: true },
        component: () => import('../views/reports/smt-coverage.vue'),
    },
    {
        path: '/reports/cancelled-orders',
        name: 'Geannuleerde orders per leverancier',
        meta: { title: 'Geannuleerde orders per leverancier', authRequired: true },
        component: () => import('../views/reports/cancelled-orders.vue'),
    },
    {
        path: '/reports/quote-funnel',
        name: 'Afhaakfunnel offertes',
        meta: { title: 'Afhaakfunnel offertes', authRequired: true },
        component: () => import('../views/reports/quote-funnel.vue'),
    },
    {
        path: '/reports/user-conversion',
        name: 'Conversie per gebruiker',
        meta: { title: 'Conversie per gebruiker', authRequired: true },
        component: () => import('../views/reports/user-conversion.vue'),
    },
    {
        path: '/reports/suppliers',
        name: 'Leveranciers & producten',
        meta: { title: 'Leveranciers & producten', authRequired: true },
        component: () => import('../views/reports/supplier-insights.vue'),
    },
    {
        path: '/reports/product-analysis',
        name: 'Product Analyse',
        meta: { title: 'Product Analyse (Google Ads)', authRequired: true },
        component: () => import('../views/reports/product-analysis.vue'),
    },
    {
        path: '/reports/email-response',
        name: 'Reactiesnelheid e-mail',
        meta: {
            title: 'Reactiesnelheid e-mail',
            authRequired: true,
            allowedEmails: ['contact@cornerstones.nl'],
        },
        component: () => import('../views/reports/email-response.vue'),
    },
    {
        path: '/discounts/list',
        name: 'Kortingsafspraken',
        meta: { title: 'Kortingsafspraken', authRequired: true },
        component: () => import('../views/discounts/list.vue'),
    },
    {
        path: '/discounts/create',
        name: 'Nieuwe kortingsafspraak',
        meta: { title: 'Nieuwe kortingsafspraak', authRequired: true },
        component: () => import('../views/discounts/form.vue'),
    },
    {
        path: '/discounts/detail/:entityId',
        name: 'Kortingsafspraak bewerken',
        meta: { title: 'Kortingsafspraak bewerken', authRequired: true },
        component: () => import('../views/discounts/form.vue'),
    },
    {
        path: '/notifications/list',
        name: 'Notificaties',
        meta: { title: 'Notificaties', authRequired: true },
        component: () => import('../views/notifications/list'),
    },
    {
        path: '/tasks/list',
        name: 'Taken',
        meta: { title: 'Taken', authRequired: true },
        component: () => import('../views/tasks/list'),
    },
    {
        path: '/after-sales/list',
        name: 'After sales',
        meta: { title: 'After sales', authRequired: true },
        component: () => import('../views/after-sales/list'),
    },
    {
        path: '/abandoned-carts/list',
        name: 'Abandonded carts',
        meta: { title: 'Verlaten offertes', authRequired: true },
        component: () => import('../views/abandoned-carts/list'),
    },
    {
        path: '/payments/list',
        name: 'Betalingen',
        meta: { title: 'Betalingen', authRequired: true },
        component: () => import('../views/payments/list'),
    },
    {
        path: '/credit-invoices/list',
        name: 'Creditfacturen',
        meta: { title: 'Creditfacturen', authRequired: true },
        component: () => import('../views/credit-invoices/list'),
    },
    {
        path: '/price-checker/list',
        name: 'Prijs checker',
        meta: { title: 'Prijs checker', authRequired: true },
        component: () => import('../views/price-checker/list'),
    },
    {
        path: '/price-checker/detail/:entityId',
        name: 'Prijs checker detail',
        meta: { title: 'Prijs checker detail', authRequired: true },
        component: () => import('../views/price-checker/detail'),
    },
];
